import { create } from "zustand";

// Lets a card open the conversation composer's file picker ("Share one" on a
// skipped capture request) without reaching into the composer. The composer
// registers its picker while it is mounted; the card only offers the action
// when one is registered.

interface ComposerAttachState {
  openPicker?: () => void;
}

export const useComposerAttachStore = create<ComposerAttachState>()(() => ({
  openPicker: undefined,
}));

/** Registers the composer's picker; returns the unregister function. */
export const registerComposerAttach = (openPicker: () => void) => {
  useComposerAttachStore.setState({ openPicker });
  return () => {
    if (useComposerAttachStore.getState().openPicker === openPicker) {
      useComposerAttachStore.setState({ openPicker: undefined });
    }
  };
};
